<template>
<div class="active-programs-page">
  <div v-show="!isDetail">
    <p class="section-title">Active Programs</p>
    <p class="section-sub-title">Here is a summary of your current programs: </p>
    <div v-for="(item, index) in viewLoans" :key="index">
      <div class="active-program-home">
        <!-- title -->
        <div class="program-name">{{ item.name }}</div>
        <div class="active-program-container-home">
          <!-- Progtrams -->
          <div class="program-fields">
             <div class="program-item-home-nca">
              <div class="program-item-fields-nca">
                <div class="table-title">Next due date:</div>
                <div class="table-title">Status:</div>
              </div>
              <div class="program-item-fields-nca">
                <div>
                  <svg-icon :name="'calendar'"></svg-icon>
                  <span>{{ item.nextDueDate }} </span>
                </div>
                <div>
                  <svg-icon :name="'check-circle'" v-show="isShowIcon('Good Standing', item.loanStatus)"></svg-icon>
                  <svg-icon :name="'past-due'" v-show="isShowIcon('Days Late', item.loanStatus)"></svg-icon>
                  <svg-icon :name="'charge-off'" v-show="isShowIcon('Charge Off', item.loanStatus)"></svg-icon>
                  <span>{{ item.loanStatus }} </span>
                </div>
              </div>
            </div>
            <div class="program-item-home-nca">
              <div class="program-item-fields-nca">
                <div class="table-title">Next payment due:</div>
                <div class="table-title">Loan balance:</div>
              </div>
              <div class="program-item-fields-nca">
                <div>
                  <svg-icon :name="'currency-dollar'"></svg-icon>
                  <span>${{ item.nextPaymentAmount }} </span>
                </div>
                <div>
                  <svg-icon :name="'currency-dollar'"></svg-icon>
                  <span>${{ item.loanBalance }} </span>
                </div>
              </div>
            </div>
          </div>
          <!-- buttons -->
          <div class="program-item-buttons-home">
            <maf-button :name="'View loan'" :width="159" @actionFunc="viewDetails(item, index)" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'"/>
           <!--  <maf-button :name="'Submit a request'" :width="205" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'"/> -->
           <div class="virtual-card" v-show="isShowVirtualCard(item)">
            <virtual-card
              ref="virtualCard"
              :isDetails="isDetail"
              :loanIndex="index"
              :loanId="item.id"
            >
            </virtual-card>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in viewIFRPs" :key="index">
      <div class="ifrp-pc-data">
        <div class="active-program-home">
          <!-- title -->
          <div class="program-name">{{ item.name }}</div>
          <div class="active-program-container-home">
            <!-- Progtrams -->
            <div class="program-fields">
              <div class="program-item-home-ifrp">
                <div class="program-item-field-ifrp"> Grant start date:
                  <div>
                    <svg-icon :name="'calendar'"></svg-icon>
                    <span>{{ item.grantStartDate }} </span>
                  </div>
                </div>
                <div class="program-item-field-end-date">Grant end date:
                  <div>
                    <svg-icon :name="'calendar'"></svg-icon>
                    <span>{{ item.grantEndDate }} </span>
                  </div>
                </div>
              </div>
              <div class="program-item-home-ifrp">
                <div class="program-item-field-month-amount">Monthly grant amount:
                  <div>
                    <svg-icon :name="'currency-dollar'"></svg-icon>
                    <span>{{ item.grantAmount }} </span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ifrp-moblic-data">
        <div class="active-program-home">
          <!-- title -->
          <div class="program-name">{{ item.name }}</div>
          <div class="active-program-container-home">
            <!-- Progtrams -->
            <div class="program-fields">
              <div class="program-item-home-ifrp">
                <div class="program-item-field-month-amount"> Grant start date:
                  <div>
                    <svg-icon :name="'calendar'"></svg-icon>
                    <span>{{ item.grantStartDate }} </span>
                  </div>
                </div>
              </div>
              <div class="program-item-home-ifrp">
                <div class="program-item-field-month-amount">Grant end date:
                  <div>
                    <svg-icon :name="'calendar'"></svg-icon>
                    <span>{{ item.grantEndDate }} </span>
                  </div>
                </div>
              </div>
              <div class="program-item-home-ifrp">
                <div class="program-item-field-month-amount">Monthly grant amount:
                  <div>
                    <svg-icon :name="'currency-dollar'"></svg-icon>
                    <span>{{ item.grantAmount }} </span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="active-program-detail-page" v-show="isDetail">
    <div class="back-arrow" @click="back" v-show="isDetail" tabindex="0" @keydown.enter.space.stop="back" style="outline: none; cursor: pointer;">
        <svg-icon :name="'back-arrow'"></svg-icon>
        <span>Back</span>
    </div>
    <p class="section-title">{{ selectedLoan.name }}</p>
    <p class="section-sub-title">Here is your current loan information </p>
    <div>
      <div class="current-loan-info-pc">
        <div class="loan-infos">
          <div class="loan-info border">
            <div class="loan-info-label">Status: </div>
            <div class="loan-info-value">
              <svg-icon :name="'check-circle'" v-show="isGoodStanding"></svg-icon>
              <svg-icon :name="'past-due'" v-show="isPastDue"></svg-icon>
              <svg-icon :name="'charge-off'" v-show="isChargeOff"></svg-icon>
              <span>{{ selectedLoan.loanStatus }}</span>
            </div>
            <div class="loan-info-label">Next due date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.nextDueDate }}</span>
            </div>
          </div>
          <div class="loan-info border">
            <div class="loan-info-label">Next payment due: </div>
            <div class="loan-info-value">
              <svg-icon :name="'currency-dollar'"></svg-icon>
              <span>${{ selectedLoan.nextPaymentAmount }}</span>
            </div>
            <div class="loan-info-label">Distribution date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.distributionDate }}</span>
            </div>
          </div>
          <div class="loan-info border">
            <div class="loan-info-label">Loan amount: </div>
            <div class="loan-info-value">
              <svg-icon :name="'currency-dollar'"></svg-icon>
              <span>${{ selectedLoan.loanAmount }}</span>
            </div>
            <div class="loan-info-label">Loan start date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.loanStartDate }}</span>
            </div>
          </div>
          <div class="loan-info">
            <div class="loan-info-label">Loan balance: </div>
            <div class="loan-info-value">
              <svg-icon :name="'accounting-document'"></svg-icon>
              <span>${{ selectedLoan.loanBalance }}</span>
            </div>
            <div class="loan-info-label">Loan end date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.loanEndDate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="current-loan-info-mobile">
        <div class="loan-infos">
          <div class="loan-info">
              <span class="loan-svg">
                <svg-icon :name="'check-circle'" v-show="isGoodStanding"></svg-icon>
                <svg-icon :name="'past-due'" v-show="isPastDue"></svg-icon>
                <svg-icon :name="'charge-off'" v-show="isChargeOff"></svg-icon>
                </span>
              <span>Status: &nbsp;</span>
              <span>{{ selectedLoan.loanStatus }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg">
              <svg-icon :name="'currency-dollar'"></svg-icon>
            </span>
            <span>Next payment due: &nbsp;</span>
            <span>${{ selectedLoan.nextPaymentAmount }}</span>
          </div>
          <div class="loan-info">
              <span class="loan-svg"><svg-icon :name="'currency-dollar'"></svg-icon></span>
              <span>Loan amount: &nbsp;</span>
              <span>${{ selectedLoan.loanAmount }}</span>
          </div>
          <div class="loan-info">
              <span class="loan-svg"><svg-icon :name="'accounting-document'"></svg-icon></span>
              <span>Loan balance: &nbsp;</span>
              <span>${{ selectedLoan.loanBalance }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Next due date: &nbsp;</span>
            <span>{{ selectedLoan.nextDueDate }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Distribution date: &nbsp;</span>
            <span>{{ selectedLoan.distributionDate }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Loan start date: &nbsp;</span>
            <span>{{ selectedLoan.loanStartDate }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Loan end date: &nbsp;</span>
            <span>{{ selectedLoan.loanEndDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isShowChangeBankAccount">
      <plaid-link
        ref="plaidLink"
        :btnDisabled="btnDisabled"
        :btnName="btnName"
        :appId="selectedLoan.appId"
        :loanIndex="selectedLoan.loanIndex"
        :loanId="selectedLoan.id"
        :accountNumberMask="accountNumberMask"
        :isShowAccountNumber="isShowAccountNumber"
      >
      </plaid-link>
    </div>
    <div v-show="isShowVirtualCard(selectedLoan)" style="margin-top: 30px; margin-bottom: 40px;">
      <virtual-card
        ref="virtualCardDetail"
        :isDetails="isDetail"
        :loanIndex="selectedLoan.loanIndex"
        :loanId="selectedLoan.id"
      >
      </virtual-card>
    </div>
    <p class="section-sub-title">Here is your payment activity </p>
    <div class="payment-activity">
      <div class="payment-activity-pc">
        <div class="payment-transaction-items">
          <div class="table-title">Date</div>
          <div class="table-title">Amount</div>
          <div class="table-title">Principal</div>
          <div class="table-title">Fees</div>
          <div class="table-title">Interest</div>
          <div class="table-title">Status</div>
        </div>
        <div v-for="(payment, index) in selectedLoan.loanPaymentTransactions" :key="index">
          <div class="payment-transaction-items">
            <div>{{  payment.transactionDate }}</div>
            <div>${{  payment.transactionAmount }}</div>
            <div>${{  payment.principal }}</div>
            <div>${{  payment.fees }}</div>
            <div>${{  payment.interest }}</div>
            <div>{{  payment.computedPaymentStatus }}</div>
          </div>
        </div>
        <div class="payment-transaction-items">
          <div>Total</div>
          <div>${{ selectedLoan.totalAmount }}</div>
          <div>${{ selectedLoan.totalPrincipal }}</div>
          <div>${{ selectedLoan.totalFees }}</div>
          <div>${{ selectedLoan.totalInterest }}</div>
          <div></div>
        </div>
      </div>
      <div class="payment-activity-mobile">
        <div v-show="noPaymentTransactions" style="color: #878787;padding: 10px;">No recorded payment activity</div>
        <div v-for="(payment, index) in selectedLoan.loanPaymentTransactions" :key="index">
          <div class="activity-card">
            <div class="unfold-infos" v-show="payment.isFold">
              <div class="unfold-info">
                <span>Date: {{ payment.transactionDate }}</span>
                <span>Amount: ${{ payment.transactionAmount }}</span>
                <span>Status: {{  payment.computedPaymentStatus }}</span>
              </div>
              <div class="unfold-arrow">
                <span @click="unfold(index)"><svg-icon :name="'dropdown'" :width="12" :height="12"></svg-icon></span>
              </div>
            </div>
            <div class="fold-infos" v-show="!payment.isFold">
              <div class="fold-info">
                <span>Date: {{ payment.transactionDate }}</span>
                <span>Amount: ${{ payment.transactionAmount }}</span>
                <span>Principal: ${{ payment.principal }}</span>
                <span>Fees: ${{ payment.fees }}</span>
                <span>Interest: ${{ payment.interest }}</span>
                <span>Status: {{  payment.computedPaymentStatus }}</span>
              </div>
              <div class="fold-arrow">
                <span @click="fold(index)"><svg-icon class="drop-up" :name="'dropdown'" :width="12" :height="12"></svg-icon></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="section-sub-title">Here are your loan statements</p>
    <div class="payment-activity">
      <div class="loan-statement-pc">
        <div class="statement-lables">
          <div class="statement-lable name">Loan Statement</div>
          <div class="statement-lable button">Download link</div>
        </div>
        <div v-for="file in selectedLoan.paymentFiles" :key="file.id">
          <div class="statement-values">
            <div class="statement-doc notranslate">{{ file.name }}</div>
            <div class="statement-button button">
              <div class="download-button"><maf-button :name="'Download'" :width="135" @actionFunc="download(file.id)"></maf-button></div>
            </div>
          </div>
        </div>
      </div>
      <div class="loan-statement-mobile">
        <div v-show="noPaymentFiles" style="color: #878787;padding: 10px;">No recorded loan statement</div>
        <div v-show="!noPaymentFiles" v-for="file in selectedLoan.paymentFiles" :key="file.id">
          <div class="statement-file">
            <div class="file-name notranslate">{{ file.name }}</div>
            <div class="download-button"><maf-button :name="'Download'" :width="135" @actionFunc="download(file.id)"></maf-button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <svg-icon :name="'green-color'"></svg-icon>
</div>
</template>

<script>
import { mapState } from 'vuex';
import PlaidLink from '../common/PlaidLink.vue';
import CheckingAccount from '../common/CheckingAccount.vue';
import VirtualCard from '../common/VirtualCard.vue';
import { getViewLoansRemoting } from '../../api'

export default {
  components: { PlaidLink, CheckingAccount, VirtualCard },
  name: 'ActivePrograms',
  data () {
    return {
      selectedLoan: {},
      isDetail: false,
    };
  },
  computed: {
    ...mapState({
      viewLoans: state => state.dashboardHomeData.program.activeProgram.viewLoans,
      viewIFRPs: state => state.dashboardHomeData.program.activeProgram.viewIFRPs,
      currentTab: state => state.currentTab,
      userInfo: state => state.userInfo,
    }),
    isGoodStanding() {
      return this.selectedLoan.loanStatus && this.selectedLoan.loanStatus.indexOf('Good Standing') !== -1;
    },
    isPastDue() {
      return this.selectedLoan.loanStatus && this.selectedLoan.loanStatus.indexOf('Days Late') !== -1;
    },
    isChargeOff() {
      return this.selectedLoan.loanStatus && this.selectedLoan.loanStatus.indexOf('Charge Off') !== -1;
    },
    isShowChangeBankAccount() {
      return !this.isChargeOff && this.selectedLoan.loanBalance && Number(this.selectedLoan.loanBalance.replace(/,/g, '')) > 0;
    },
    isHome() {
      return this.currentTab.label === 'Home';
    },
    noPaymentFiles() {
      let tempAarry = [];
      tempAarry = tempAarry.concat(this.selectedLoan.paymentFiles)
      return tempAarry.length === 0;
    },
    noPaymentTransactions() {
      let tempAarry = [];
      tempAarry = tempAarry.concat(this.selectedLoan.loanPaymentTransactions)
      return tempAarry.length === 0;
    },
    btnName() {
      if (!this.selectedLoan.isUpdateButtonPending) {
        return 'Change bank account';
      }

      if (this.selectedLoan.isUpdateButtonPending && this.selectedLoan.verificationMethod === 'Plaid') {
        return 'Account change pending';
      }

      if (this.selectedLoan.isUpdateButtonPending && this.selectedLoan.verificationMethod === 'Manual') {
        return 'Account change requested';
      }
    },
    btnDisabled() {
      if (this.selectedLoan.isUpdateButtonPending || this.selectedLoan.isUpdateButtonDisabled) {
        return true;
      } else {
        return false;
      }
      // test1
    },
    isShowAccountNumber() {
      return !this.selectedLoan.isUpdateButtonPending && this.selectedLoan.accountNumber;
    },
    accountNumberMask() {
      if (!this.selectedLoan.accountNumber) {
        return '';
      }
      let accountNumber = this.selectedLoan.accountNumber;
      if (accountNumber.length === 4) {
        accountNumber = '*****' + accountNumber;
      }
      let number = accountNumber.slice(-4).padStart(accountNumber.length, '*');
      let numberPrefix = number.slice(0, number.length - 4);
      let numberSuffix = number.slice(-4);
      return numberPrefix + numberSuffix;
    }
  },
  mounted() {
    this.setRecordById();
  },
  methods: {
    viewDetails(loan, index) {
      this.isDetail = true;
      this.selectedLoan = loan;
      this.selectedLoan.loanIndex = index;
      this.$router.push(`/activePrograms/${this.selectedLoan.id}`);

      this.$nextTick(() => {
        document.getElementById('mainPage').scrollIntoView();
      })
    },
    setRecordById() {
      const id = this.$route.params.recordId;
      if (id) {
        let viewRecord = this.viewLoans.filter((item, index) => {
          if ((item.id).substring(0, 15) === id.substring(0, 15)) {
            item.loanIndex = index;
            return true;
          }
          return false
        });
        if (viewRecord) {
          this.viewDetails(viewRecord[0], viewRecord[0].loanIndex);
        } else {
          console.error('No matching record found by Id');
        }
      }
    },
    back() {
      this.$router.push('/activePrograms'); // Remove Id from URL
      this.isDetail = false;
    },

    async download(fileId) {
      await getViewLoansRemoting(this.userInfo.userId);
      window.open('/lendingcircles/servlet/servlet.FileDownload?file=' + fileId, '_blank');
    },

    unfold(index) {
      this.selectedLoan.loanPaymentTransactions[index].isFold = false;
    },

    fold(index) {
      this.selectedLoan.loanPaymentTransactions[index].isFold = true;
    },

    isShowIcon(sourceState, currentState) {
      if (currentState) {
        return currentState.indexOf(sourceState) !== -1;
      } else {
        return false;
      }
    },
    isShowVirtualCard(loan) {
      return loan.programCategory !== null && loan.programCategory === 'Immigration' && loan.loanStatus.indexOf('Charge Off') < 0;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /*pc*/
  @import './../../sass/main.scss';
  .active-programs-page {
    padding: 50px;
    font-size: $font-size-large;
    width: 100%;
    height: 100%;

    /*mobile*/
    @media only screen and (max-width: $max-width-phone) {
      padding: 20px;
      font-size: $font-size-base;
      width: unset;
      height: 100%;
    }

    .active-program-home {
      background-color: rgb(244, 244, 244);
      max-width: 906px;
      color: #878787;
      border-radius: 7px;
      margin-bottom: 10px;

      .program-name {
        padding: 15px;
      }

      @media only screen and (max-width: $max-width-phone) {
        max-width: unset;
      }

      .active-program-container-home {
        display: flex;
        justify-content: space-between;

        @media only screen and (max-width: $max-width-phone) {
          flex-direction: column;
        }

        .program-fields {
          flex: 1;

          @media only screen and (max-width: $max-width-phone) {
            padding: 15px;
            border-bottom: 2px solid white;
            border-top: 2px solid white;
            font-size: 15px;
          }

          .program-item-home-ifrp {
            display: flex;
            padding: 15px;
            line-height: 1.3;
            .space-between {
              justify-content: space-between;
            }
            .sa-program {
              width: 250px !important;
            }

            @media only screen and (max-width: $max-width-phone) {
              padding: 15px 0px 15px 0px;
            }

            .program-item-field {
              width: 300px;

              div {
                display: flex;
                align-items: center;

                span {
                  margin-left: 10px;
                }
              }
            }

            .program-item-field-end-date {
              width: 500px;
              word-break: break-word;

              div {
                display: flex;
                align-items: center;

                span {
                  margin-left: 10px;
                }
              }

              @media only screen and (max-width: $max-width-phone) {
                width: 175px;
              }
            }

            .program-item-field-ifrp {
              width: 300px;
              word-break: break-word;

              div {
                display: flex;
                align-items: center;

                span {
                  margin-left: 10px;
                }
              }

              @media only screen and (max-width: $max-width-phone) {
                width: 175px;
              }
            }

            .program-item-field-month-amount {
              width: 500px;
              word-break: break-word;

              div {
                display: flex;
                align-items: center;

                span {
                  margin-left: 10px;
                }
              }

              @media only screen and (max-width: $max-width-phone) {
                width: 300px;
              }
            }
          }
        }

        .program-item-buttons-home {
          padding: 15px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: inherit;
          width: 330px;

          @media only screen and (max-width: $max-width-phone) {
            padding: 10px;
            width: unset;
            align-items: center;

            .maf-btn {
              width: 100% !important;
              margin-bottom: 8px;
              margin-top: 8px;
            }
          }
        }
      }
    }

    .section-title {
      font-size: 25px;
      color: #834BC4;

      @media only screen and (max-width: $max-width-phone) {
        margin-top: 10px;
        font-size: 20px;
      }
    }

    .section-sub-title {
      margin-bottom: 20px;
      margin-top: 20px;
      color: $font-color-sub-title;
      font-size: $font-size-larger;

      @media only screen and (max-width: $max-width-phone) {
        margin-bottom: 10px;
        margin-top: 10px;
        font-size: $font-size-large;
      }
    }

    .back-arrow {
      margin-bottom: 20px;
      @include space-between-style;
      width: 70px;
      color: $font-color-sub-title;
      cursor: pointer;
    }

  .program-item {
    @include inline-flex-row;
    margin-bottom: 10px;
    width: 100%;
    border-radius: 7px;
    color: $font-color-sub-title;
    background-color:  #F4F4F4;

    @media only screen and (max-width: $max-width-phone) {
      @include inline-flex-col;
      margin-bottom: 20px;
    }

    .loan-item {
      padding: 15px;
      @include center-style;
      justify-content: flex-start;
      line-height: 1.3;
      height: 72px;

      @media only screen and (max-width: $max-width-phone) {
        @include inline-flex-row;
        justify-content: flex-start;
        align-items: center;
        width: unset;
      }
    }

    .loan-name {
      flex: 1;
      justify-content: flex-start;
      height: auto;

      @media only screen and (max-width: $max-width-phone) {
        width: unset;
        padding: 15px;
      }
    }

    .loan-date-pc {
      flex-direction: column;
      width: 205px;
      padding-bottom: 5px;
      border-left: 2px solid $bg-color-white;
      border-right: 2px solid $bg-color-white;
      height: auto;

      .loan-date-svg {
        display: flex;
        align-items: center;

        .loan-svg {
          padding-right: 10px;
        }
      }
    }

    .loan-date-mobile {
      display: none;
    }

    @media only screen and (max-width: $max-width-phone) {
      .loan-date-pc {
        display: none;
      }

      .loan-date-mobile {
        display: flex;
        padding: 15px;
        width: unset;
        border-top: 2px solid white;
        border-bottom: 2px solid white;

        .loan-svg {
          margin-right: 5px;
        }
      }
    }

     .loan-button {
      justify-content: center;
      width: 225px;
      height: auto;

      @media screen and (max-width: $max-width-phone) {
        width: unset;
        padding: 15px;

        .maf-btn {
          width: 100% !important;
        }
      }
    }
  }

  .ifrp-moblic-data {
    display: none;
  }

  @media only screen and (max-width: $max-width-phone) {
    .virtual-card {
      width: 100%;
    }
    .ifrp-pc-data {
      display: none;
    }

    .ifrp-moblic-data {
      display: flex;

      .active-program-home {
        width: -webkit-fill-available;
      }
    }
  }

  .current-loan-info-mobile {
    display: none;
  }

  .current-loan-info-pc {
    margin-bottom: 40px;

    .loan-infos {
      background-color:  #F4F4F4;
      color: $font-color-sub-title;
      border-radius: 7px;
      @include inline-flex-row;
      justify-content: space-between;
      width: 100%;
      min-height: 154px;

      .loan-info {
        padding: 15px;
        flex: 1;
        line-height: 1.3;

        .loan-info-label {
          padding-top: 10px
        }

        .loan-info-value {
          display: flex;
          align-items: center;

          span {
            margin-left: 10px;
          }
        }
      }
    }

    .border {
      border-right: 2px solid white;
    }
  }

  @media only screen and (max-width: $max-width-phone) {
    .current-loan-info-pc {
      display: none;
    }

    .current-loan-info-mobile {
      @include inline-flex-col;
      margin-bottom: 20px;
      width: 100%;

      .loan-infos {
        background-color:  #F4F4F4;
        color: $font-color-sub-title;
        border-radius: 7px;
        @include inline-flex-col;
        justify-content: space-between;
        font-size: 15px;

        .loan-info {
          padding: 15px;
          @include inline-flex-row;
          border: 1px solid white;

          .loan-svg {
            padding-right: 10px;
          }
        }
      }
    }
  }
  .payment-activity {
    background-color:  #F4F4F4;
    border-radius: 7px;
  }

  .payment-activity-mobile {
    display: none;
  }

  .payment-activity-pc {
    margin-bottom: 40px;
    width: 100%;
    border-radius: 7px;

    .payment-transaction-items {
      color: #393C40;
      font-size: $font-size-base;
      @include flex-row;
      justify-content: space-between;
      border-top: 2px solid white;
      font-family: sans-serif;

      div {
        padding: 15px;
        flex: 1;
      }

      .table-title {
        color: $font-color-sub-title;
        font-family: ncaDashboardFont, Arial, sans-serif;
      }
    }
  }

  .program-item-home-nca {
    padding: 15px;
    line-height: 1.3;
    width: 100%;

    @media only screen and (max-width: $max-width-phone) {
      padding: 0px 0px 5px 0px;
      line-height: 1.7;
      width: 100%;
    }

    .program-item-fields-nca {
      color: #878787;
      @include flex-row;

      div {
        width: 300px;
        flex: 1;
      }

      .table-title {
        color: $font-color-sub-title;
      }
    }
  }

  @media only screen and (max-width: $max-width-phone) {
    .payment-activity-pc {
      display: none;
    }

    .payment-activity-mobile {
      @include inline-flex-col;
      /* margin-bottom: 20px; */
      width: 100%;

      .activity-card {
        @include inline-flex-col;
        margin-bottom: 10px;
        color: $font-color-sub-title;
        justify-content: space-between;
        font-size: 15px;
        width: 100%;
        border-radius: 7px;
        background-color:  #F4F4F4;

        .unfold-infos {
          @include inline-flex-row;
          padding: 10px;
          justify-content: space-around;

          .unfold-info {
            @include inline-flex-col;
            flex: 1;

            span {
              padding-bottom: 5px;
            }
          }

          .unfold-arrow {
            padding-top: 12px;
          }
        }

        .fold-infos {
          @include inline-flex-row;
          justify-content: space-around;
          padding: 10px;

          .fold-info {
            @include inline-flex-col;
            flex: 1;

            span {
              padding-bottom: 5px;
            }
          }

          .fold-arrow {
            padding-top: 12px;

            .drop-up {
              transform: rotateX(180deg);
            }
          }
        }
      }
    }
  }

  .loan-statement-mobile {
    display: none;
  }

  .loan-statement-pc {
    margin-bottom: 20px;
    background-color:  #F4F4F4;
    border-radius: 7px;
    width: 100%;

    .statement-lables {
      @include flex-row;
      justify-content: space-between;
      align-items: flex-start;
      height: 50px;
      color: $font-color-sub-title;

      .statement-lable {
        padding: 15px;
      }

      .button {
        width: 200px;
      }
    }

    .statement-values {
      @include flex-row;
      justify-content: space-between;
      border-top: 2px solid white;
      font-size: $font-size-base;
      color: #393C40;

      .statement-doc {
        flex: 1;
        padding: 15px;
        font-family: sans-serif;
      }

      .statement-button {
        margin-top: 5px;
        width: 200px;
      }
    }
  }

  @media only screen and (max-width: $max-width-phone) {
    .loan-statement-pc {
      display: none;
    }

    .loan-statement-mobile {
      @include inline-flex-col;
      width: 100%;

      .statement-file {
        @include inline-flex-col;
        padding: 10px;
        margin-bottom: 10px;
        width: 100%;
        border-radius: 7px;
        background-color: #F4F4F4;

        .file-name {
          padding-bottom: 10px;
          font-size: 15px;
          color: $font-color-sub-title;
        }

        .download-button {
          padding-bottom: 10px;
          width: 100%;

          @media only screen and (max-width: $max-width-phone) {
            .maf-btn {
              width: 100% !important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/active-programs/ActivePrograms.vue